import Marquee from "react-fast-marquee";

export default function ClientLogos({ clients = [] }) {
  if (!clients.length) return null;
  return (
    <section className="max-w-[1600px] mx-auto px-6 md:px-10 py-20 md:py-28" data-testid="clients-section">
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-white/40 mb-12 text-center">
        Trusted by teams building the future
      </p>
      <Marquee speed={30} gradient gradientColor="#050505" gradientWidth={120} autoFill>
        {clients.map((c, i) => (
          <div key={i} className="mx-10 md:mx-16 flex items-center gap-3 opacity-50 hover:opacity-100 transition-opacity" data-testid={`client-${i}`}>
            <span className="w-2.5 h-2.5 bg-[color:var(--accent)]" />
            <span className="font-display text-2xl md:text-3xl uppercase tracking-tight text-white whitespace-nowrap">{c.name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
